import React from 'react';
import bn from "../../../utils/bemnames";
import {getDefaultCompetitorImage} from '../../../utils/competitor';
import {_t} from '../../../utils/translations';
import {EventPositions, IEventCompetitor} from '../../../utils/types';
import ImgWithDefault from '../../ImgWithDefault';

const bem = bn.create('outright-odds-event');

interface IProps {
  eventCompetitors: IEventCompetitor[];
  isMobile?: boolean;
  sportId?: number;
}

const Event: React.FC<IProps> = ({eventCompetitors, isMobile = false, sportId = null}) => {
  const getEventCompetitorByPosition = (position: EventPositions): IEventCompetitor|undefined => eventCompetitors.find(eventCompetitor => eventCompetitor.position === position)
  const getCompetitorTrNameByPosition = (position: EventPositions): string => getEventCompetitorByPosition(position)?.competitor?.trName ?? ' - '
  const getCompetitorLogoByPosition = (position: EventPositions): string => getEventCompetitorByPosition(position)?.competitor?.logoUrl ?? getDefaultCompetitorImage(sportId)

  return (
    <>
      {isMobile && (
        <div className={`${bem.b()} ${isMobile ? bem.m('mobile') : ''}`}>
          <div className={`${bem.e('column')} ${(isMobile) ? bem.e('column-left') : ''}`}>{getCompetitorTrNameByPosition(EventPositions.home)}</div>
          <div className={bem.e('column-center')}>
            <div className={bem.e('column')}>
              <ImgWithDefault
                className={bem.e('competitor-logo')}
                alt={getCompetitorTrNameByPosition(EventPositions.home)}
                src={getCompetitorLogoByPosition(EventPositions.home)}
              />
            </div>
            <div className={bem.e('column center')}>{_t('v')}</div>
            <div className={bem.e('column')}>
              <ImgWithDefault
                className={bem.e('competitor-logo')}
                alt={getCompetitorTrNameByPosition(EventPositions.away)}
                src={getCompetitorLogoByPosition(EventPositions.away)}
              />
            </div>
          </div>
          <div className={`${bem.e('column')} ${(isMobile) ? bem.e('column-right') : ''}`}>{getCompetitorTrNameByPosition(EventPositions.away)}</div>
        </div>
      )}
      {!isMobile && (
        <div className={bem.b()}>
          <div className={`${bem.e('column')} ${(isMobile) ? bem.e('column-mobile') : ''}`}>{getCompetitorTrNameByPosition(EventPositions.home)}</div>
          <div className={bem.e('column')}>
            <ImgWithDefault
              className={bem.e('competitor-logo')}
              alt={getCompetitorTrNameByPosition(EventPositions.home)}
              src={getCompetitorLogoByPosition(EventPositions.home)}
            />
          </div>
          <div className={bem.e('column')}>{_t('v')}</div>
          <div className={bem.e('column')}>
            <ImgWithDefault
              className={bem.e('competitor-logo')}
              alt={getCompetitorTrNameByPosition(EventPositions.away)}
              src={getCompetitorLogoByPosition(EventPositions.away)}
            />
          </div>
          <div className={`${bem.e('column')} ${(isMobile) ? bem.e('column-mobile') : ''}`}>{getCompetitorTrNameByPosition(EventPositions.away)}</div>
        </div>
      )}
    </>
  )
}

export default Event;
